export default {
    getCountryDynamic(state){
        let country = []
        state.dataCountryTH.map((item)=>{
          country.push({label:item.enName,value:item.numeric})
        })
        return country
    },
    getProvinceDynamic(state){
        let province = []
        state.provinceTh.map((item)=>{
            province.push({label:item.name,value:item.pid})
        })
        return province
    },
    getalllanguage(state){
        let language = []
        
        state.alllanguage.map((item)=>{
            language.push({label:item.name})
        })
        console.log(language.length)
        return language
    },
};
